"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Status = exports.PaymentMethod = exports.Method = exports.Importance = void 0;

var _EventHandler = _interopRequireDefault(require("../../Events/EventHandler"));

var _Payer = _interopRequireWildcard(require("./Payer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const PaymentMethod = {
  CREDIT: 1,
  DEBIT: 2,
  VOUCHER: 4,
  MONEY: 8,
  FISICO: 16,
  ONLINE: 32
};
exports.PaymentMethod = PaymentMethod;
const Importance = {
  HIGH: 100,
  MEDIUM_HIGH: 80,
  MEDIUM: 50,
  LOW_MEDIUM: 40,
  LOW: 20
};
exports.Importance = Importance;
const Status = {
  WAITING: 0,
  PAYED: 1
};
exports.Status = Status;
const Method = {
  ABRAPETITE_ALIMENTACAO: {
    alias: 'ABRAPETITE_ALIMENTACAO',
    name: 'Abrapetite',
    type: PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  ABRAPETITE_REFEICAO: {
    'alias': 'ABRAPETITE_REFEICAO',
    'name': 'Abrapetite',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  ALELO_ALIMENTACAO: {
    'alias': 'ALELO_ALIMENTACAO',
    'name': 'Alelo',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.HIGH
  },
  ALELO_REFEICAO: {
    'alias': 'ALELO_REFEICAO',
    'name': 'Alelo',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.HIGH
  },
  AMERICAN_EXPRESS: {
    'alias': 'AMERICAN_EXPRESS',
    'name': 'American Express',
    'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
    'importance': Importance.MEDIUM
  },
  AURA: {
    'alias': 'AURA',
    'name': 'Aura',
    'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  BANESE: {
    'alias': 'BANESE',
    'name': 'Banese',
    'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  BANESCARD_CREDITO: {
    'alias': 'BANESCARD_CREDITO',
    'name': 'Banescard',
    'type': PaymentMethod.CREDIT | PaymentMethod.FISICO | PaymentMethod.ONLINE,
    'importance': Importance.LOW
  },
  BANESCARD_DEBITO: {
    'alias': 'BANESCARD_DEBITO',
    'name': 'Banescard',
    'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  BANRICOMPRAS: {
    'alias': 'BANRICOMPRAS',
    'name': 'Banricompras',
    'type': PaymentMethod.DEBIT | PaymentMethod.CREDIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  BANRICARD_ALIMENTACAO: {
    'alias': 'BANRICARD_ALIMENTACAO',
    'name': 'Banricard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  BANRICARD_REFEICAO: {
    'alias': 'BANRICARD_REFEICAO',
    'name': 'Banricard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  BIGCARD: {
    'alias': 'BIGCARD',
    'name': 'BigCard',
    'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  BRASILCARD: {
    'alias': 'BRASILCARD',
    'name': 'BrasilCard',
    'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  CABAL: {
    'alias': 'CABAL',
    'name': 'Cabal',
    'type': PaymentMethod.CREDIT | PaymentMethod.DEBIT | PaymentMethod.FISICO | PaymentMethod.ONLINE,
    'importance': Importance.LOW
  },
  CABAL_ALIMENTACAO: {
    'alias': 'CABAL_ALIMENTACAO',
    'name': 'Cabal',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  CABAL_REFEICAO: {
    'alias': 'CABAL_REFEICAO',
    'name': 'Cabal',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  COMPROCARD_ALIMENTACAO: {
    'alias': 'COMPROCARD_ALIMENTACAO',
    'name': 'Comprocard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  COMPROCARD_REFEICAO: {
    'alias': 'COMPROCARD_REFEICAO',
    'name': 'Comprocard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  COOPER: {
    'alias': 'COOPER',
    'name': 'Cooper',
    'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE,
    'importance': Importance.LOW
  },
  COOPERCARD_ALIMENTACAO: {
    'alias': 'COOPERCARD_ALIMENTACAO',
    'name': 'Coopercard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  COOPERCARD_REFEICAO: {
    'alias': 'COOPERCARD_REFEICAO',
    'name': 'Coopercard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  CREDI_ALIMENTACAO: {
    'alias': 'CREDI_ALIMENTACAO',
    'name': 'Credi',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  CREDI_REFEICAO: {
    'alias': 'CREDI_REFEICAO',
    'name': 'Credi',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  CREDISHOP: {
    'alias': 'CREDISHOP',
    'name': 'Credishop',
    'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  CREDZ_CREDITO: {
    'alias': 'CREDZ_CREDITO',
    'name': 'Credz',
    'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  CREDZ_DEBITO: {
    'alias': 'CREDZ_DEBITO',
    'name': 'Credz',
    'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  DINERS_CLUB: {
    'alias': 'DINERS_CLUB',
    'name': 'Diners Club',
    'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  DINHEIRO: {
    'alias': 'DINHEIRO',
    'name': 'Dinheiro',
    'type': PaymentMethod.MONEY | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  DISCOVER: {
    'alias': 'DISCOVER',
    'name': 'Discover',
    'type': PaymentMethod.CREDIT | PaymentMethod.DEBIT | PaymentMethod.FISICO | PaymentMethod.ONLINE,
    'importance': Importance.LOW
  },
  DINNERS: {
    'alias': 'DINNERS',
    'name': 'Dinners',
    'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE,
    'importance': Importance.LOW
  },
  ELO: {
    'alias': 'ELO',
    'name': 'Elo',
    'type': PaymentMethod.DEBIT | PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
    'importance': Importance.MEDIUM_HIGH
  },
  GREEN_CARD_ALIMENTACAO: {
    'alias': 'GREEN_CARD_ALIMENTACAO',
    'name': 'Green Card',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  GREEN_CARD_REFEICAO: {
    'alias': 'GREEN_CARD_REFEICAO',
    'name': 'Green Card',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  GOOD: {
    'alias': 'GOOD',
    'name': 'Good',
    'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  HIPER: {
    'alias': 'HIPER',
    'name': 'Hiper',
    'type': PaymentMethod.DEBIT | PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
    'importance': Importance.MEDIUM_HIGH
  },
  HIPERCARD: {
    'alias': 'HIPERCARD',
    'name': 'Hipercard',
    'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE,
    'importance': Importance.MEDIUM_HIGH
  },
  JCB: {
    'alias': 'JCB',
    'name': 'Jcb',
    'type': PaymentMethod.CREDIT | PaymentMethod.DEBIT | PaymentMethod.FISICO | PaymentMethod.ONLINE,
    'importance': Importance.LOW
  },
  MAIS: {
    'alias': 'MAIS',
    'name': 'Mais!',
    'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  MAESTRO: {
    'alias': 'MAESTRO',
    'name': 'Maestro',
    'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  MASTERCARD: {
    'alias': 'MASTERCARD',
    'name': 'Mastercard',
    'type': PaymentMethod.DEBIT | PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
    'importance': Importance.HIGH
  },
  ONE_CARD: {
    'alias': 'ONE_CARD',
    'name': 'One Card',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  ONE_CARD_ALIMENTACAO: {
    'alias': 'ONE_CARD_ALIMENTACAO',
    'name': 'One Card',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  PLANVALE_ALIM: {
    'alias': 'PLANVALE_ALIM',
    'name': 'PlanVale',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  PLANVALE_REF: {
    'alias': 'PLANVALE_REF',
    'name': 'PlanVale Ref.',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  PERSONAL_CARD_ALIMENTACAO: {
    'alias': 'PERSONAL_CARD_ALIMENTACAO',
    'name': 'Personal Card',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  PERSONAL_CARD_REFEICAO: {
    'alias': 'PERSONAL_CARD_REFEICAO',
    'name': 'Personal Card',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  PIX: {
    'alias': 'PIX',
    'name': 'Pix',
    'type': PaymentMethod.MONEY | PaymentMethod.ONLINE,
    'importance': Importance.MEDIUM_HIGH
  },
  POLICARD_ALIMENTACAO: {
    'alias': 'POLICARD_ALIMENTACAO',
    'name': 'Policard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  POLICARD_REFEICAO: {
    'alias': 'POLICARD_REFEICAO',
    'name': 'Policard ',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  PANAL: {
    'alias': 'PANAL',
    'name': 'Panal',
    'type': PaymentMethod.CREDIT | PaymentMethod.DEBIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  REDESHOP_DEBITO: {
    'alias': 'REDESHOP_DEBITO',
    'name': 'RedeShop',
    'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
    'importance': Importance.MEDIUM
  },
  SENFF: {
    'alias': 'SENFF',
    'name': 'Senff',
    'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  SENFF_ALIMENTACAO: {
    'alias': 'SENFF_ALIMENTACAO',
    'name': 'Senff',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  SENFF_REFEICAO: {
    'alias': 'SENFF_REFEICAO',
    'name': 'Senff Refeicão',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  SOROCRED: {
    'alias': 'SOROCRED',
    'name': 'Sorocred',
    'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  SORO_VALE_ALIMENTACAO: {
    'alias': 'SORO_VALE_ALIMENTACAO',
    'name': 'Soro Vale',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  SORO_VALE_REFEICAO: {
    'alias': 'SORO_VALE_REFEICAO',
    'name': 'Soro Vale',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  SICREDI: {
    'alias': 'SICREDI',
    'name': 'Sicredi',
    'type': PaymentMethod.CREDIT | PaymentMethod.DEBIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  SAPORE_MERCATO: {
    'alias': 'SAPORE_MERCATO',
    'name': 'Sapore Mercato',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  SAPORE_RISTORANTE: {
    'alias': 'SAPORE_RISTORANTE',
    'name': 'Sapore Ristorante',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  SODEXO_REFEICAO: {
    'alias': 'SODEXO_REFEICAO',
    'name': 'Sodexo',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.MEDIUM_HIGH
  },
  SODEXO_ALIMENTACAO: {
    'alias': 'SODEXO_ALIMENTACAO',
    'name': 'Sodexo',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.MEDIUM_HIGH
  },
  TICKET_ALIMENTACAO: {
    'alias': 'TICKET_ALIMENTACAO',
    'name': 'Ticket',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.HIGH
  },
  TICKET_RESTAURANTE_REFEICAO: {
    'alias': 'TICKET_RESTAURANTE_REFEICAO',
    'name': 'Ticket Restaurante',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.HIGH
  },
  UNIONPAY: {
    'alias': 'UNIONPAY',
    'name': 'UnionPay',
    'type': PaymentMethod.CREDIT | PaymentMethod.ONLINE,
    'importance': Importance.LOW
  },
  USECRED_REFEICAO: {
    'alias': 'USECRED_REFEICAO',
    'name': 'Usecred Refeicao',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  USECRED_ALIMENTACAO: {
    'alias': 'USECRED_ALIMENTACAO',
    'name': 'Usecred',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  VALECARD_ALIMENTACAO: {
    'alias': 'VALECARD_ALIMENTACAO',
    'name': 'Valecard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  VALECARD_REFEICAO: {
    'alias': 'VALECARD_REFEICAO',
    'name': 'Valecard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  VALE_MAIS_ALIMENTACAO: {
    'alias': 'VALE_MAIS_ALIMENTACAO',
    'name': 'Vale Mais',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  VALE_MAIS_REFEICAO: {
    'alias': 'VALE_MAIS_REFEICAO',
    'name': 'Vale mais refeição ',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  VERDE_CARD: {
    'alias': 'VERDE_CARD',
    'name': 'Verde Card',
    'type': PaymentMethod.CREDIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  VEROCARD_REFEICAO: {
    'alias': 'VEROCARD_REFEICAO',
    'name': 'Verocard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  VEROCARD_ALIMENTACAO: {
    'alias': 'VEROCARD_ALIMENTACAO',
    'name': 'Verocard',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  VISA: {
    'alias': 'VISA',
    'name': 'Visa',
    'type': PaymentMethod.DEBIT | PaymentMethod.CREDIT | PaymentMethod.ONLINE | PaymentMethod.FISICO,
    'importance': Importance.HIGH
  },
  VISA_ELECTRON: {
    'alias': 'VISA_ELECTRON',
    'name': 'Visa Electron',
    'type': PaymentMethod.DEBIT | PaymentMethod.FISICO,
    'importance': Importance.LOW
  },
  VISA_VALE_ALIMENTACAO: {
    'alias': 'VISA_VALE_ALIMENTACAO',
    'name': 'Visa Vale',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.MEDIUM
  },
  VISA_VALE_REFEICAO: {
    'alias': 'VISA_VALE_REFEICAO',
    'name': 'Visa Vale',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.MEDIUM
  },
  VR_ALIMENTACAO: {
    'alias': 'VR_ALIMENTACAO',
    'name': 'VR',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.MEDIUM_HIGH
  },
  VR_REFEICAO: {
    'alias': 'VR_REFEICAO',
    'name': 'VR',
    'type': PaymentMethod.VOUCHER | PaymentMethod.FISICO,
    'importance': Importance.MEDIUM_HIGH
  },
  EASY_COINS: {
    'alias': 'EASY_COINS',
    'name': 'Créditos',
    'type': PaymentMethod.MONEY | PaymentMethod.ONLINE,
    'importance': Importance.LOW
  }
};
exports.Method = Method;

class Payment extends _EventHandler.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "payers", []);

    _defineProperty(this, "total", null);

    _defineProperty(this, "status", Status.WAITING);
  }

  static fromObject(obj) {
    let p = new Payment();
    Object.keys(obj || {}).forEach(key => {
      let value = obj[key];

      switch (key) {
        case 'status':
          p.status = value;
          break;

        case 'payers':
          p.payers = value.map(payer => _Payer.default.fromObject(payer));
          break;
      }
    });
    p.total = p.payers.reduce((carry, v) => carry + v.amount, 0);
    return p;
  }

  validate() {
    let me = this;
    let availableMethods = this.trigger('payment/getAvailableMethods'); //TODO: Verificar forma de pagamento

    let all_valid = true;

    if (this.payers.length == 0) {
      throw new Error('Pagantes não informados!');
    }

    this.payers.forEach(payer => {
      payer.on('payer/getAvailableMethods', payer => {
        return availableMethods;
      });
      payer.on('payer/getOrder', function () {
        return me.trigger('payment/getOrder', null);
      });
      payer.on('payer/getUser', function (payer) {
        return me.trigger('payment/getUser', payer);
      });
      all_valid = all_valid && payer.validate();
    });

    if (!all_valid) {
      this.status = Status.WAITING;
    } else {
      this.status = this.payers.reduce((carry, payer) => carry && payer.status == _Payer.Status.PAYED, true) ? Status.PAYED : Status.WAITING;
    }
  }

}

exports.default = Payment;